/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Accept_LabelInputs */



/**
* | output |
* | --- |
* | "Accept current correction" |
*
* @param {Spellcheck_Accept_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_accept_label = /** @type {((inputs?: Spellcheck_Accept_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Accept_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accepter la correction actuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Korrektur akzeptieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accetta la correzione corrente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принять текущую поправку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aceptar la corrección actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("接受当前修正")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の修正を受け入れる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान सुधार को स्वीकार करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aceitar correção atual")
	return /** @type {LocalizedString} */ ("Accept current correction")
});